import React from "react";
import Spinner from "../../../../Spinner";
import { SpinnerWrapper } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
export default function SpinnerAdornment() {
  return /*#__PURE__*/_jsx(SpinnerWrapper, {
    children: /*#__PURE__*/_jsx(Spinner, {
      size: "sm"
    })
  });
}